import React, {useEffect, useRef, useState} from 'react';
import Modal from '../../../../../../../../../components-new/ui/Modal';
import Translate, {t} from "../../../../../../../../../components/Translate";
import Input from "../../../../../../../../../components-new/form/Input";
import config from "../../../../../../../../../config";
import SilverButton from "../../../../../../../../../components-new/buttons/SilverButton";
import BlueButton from "../../../../../../../../../components-new/buttons/BlueButton";
import {generalModalStyles} from "../../../../../../../../../utils/General";

Modal.setAppElement('#root');

const NewFolderModal = ({
                                isOpen,
                                onSave,
                                onClose,
                                user
                            }) => {

    const [folder, setFolder] = useState('');
    const inputRef = useRef(null);

    return (
        <Modal
            closeTimeoutMS={config.closeTimeoutMS}
            isOpen={isOpen}
            onRequestClose={onClose}
            title={<Translate text="addFolder"/>}
            style={{
                ...generalModalStyles.standardModalStyles,
                content: {
                    ...generalModalStyles.standardModalStyles.content,
                    width: '420px',
                    maxWidth: 'calc(100vw - 32px)',
                },
            }}
            onAfterOpen={() => inputRef.current.focus()}
            footer={
                <React.Fragment>
                    <SilverButton type="button" width="auto" height="40px" onClick={onClose}>
                        <Translate text="close"/>
                    </SilverButton>
                    <BlueButton type="button" width="auto" height="40px" onClick={() => {
                        onSave(folder);
                        setFolder('');
                    }}>
                        <Translate text="save"/>
                    </BlueButton>
                </React.Fragment>
            }
        >
            <Input
                type="text"
                placeholder={user && t({user, text:"folderName"})}
                ref={inputRef}
                value={folder}
                onChange={e => setFolder(e.target.value)}
            />
        </Modal>
    );
};

export default NewFolderModal;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/templates/partials/NewFolderModal.jsx